module.exports = __webpack_public_path__ + "media/images/icons/outlined/underline-473827b7f1c7098d1ff3724410bb1792.svg";